import { render } from "./PricingCalculator.vue?vue&type=template&id=7a28cb46"
import script from "./PricingCalculator.vue?vue&type=script&lang=ts"
export * from "./PricingCalculator.vue?vue&type=script&lang=ts"

import "./PricingCalculator.vue?vue&type=style&index=0&id=7a28cb46&lang=scss"
script.render = render

export default script